module.exports = __webpack_public_path__ + "static/media/sensor.f6b162d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/sensor.png
// module id = 158
// module chunks = 0